import React from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '../../../../commonComponents/formComponents/inputField'
import DropDown from '../../../../commonComponents/formComponents/dropDown'
import { useSelector,useDispatch } from 'react-redux'
import DeleteIcon from '../../../../commonComponents/deleteIcon'
import { validation } from '../../../util/cdsFieldPatterns';
import {addHeaderTabWarnings,deleteHeaderTabWarnings} from "../../../actions/errorValidationActions";
import CopyRepElement from '../../itemsTab/copyRepElement'
import { useCurrentShipmentType } from '../../../../hooks/useCurrentShipmentType'
  

const PreviousDocumentsDetails = ({
  item: { id, type, code, docRef, goodsItemIdentifier },
  deleteData,
  updateData,
  saveData,
  isItemTab,
  copyData,
  isFormDisabled = false
}) => {
  const previousDocumentsType = useSelector((state) => state.DropDownValues.previousDocumentsType)
  const documentCategories = useSelector((state) => state.DropDownValues.documentCategories)
  const {isDisabled} = useCurrentShipmentType()
//   const {declarationCat = ''} = useSelector((state) => state.Shipment) || []
//   const getValidationError = React.useMemo(
//     () => validation(declarationCat, 'headerTab'),
//     [declarationCat]
//   )

//  const addErrors = (level, value, fieldName) => {
//    dispatch(addHeaderTabWarnings(level, value, fieldName))
//  }
//  const deleteErrors = (level, value, fieldName) => {
//    dispatch(deleteHeaderTabWarnings(level, value, fieldName))
//  }

  
  return (
    <Grid.Row>
      {isItemTab && (
        <Grid.Column width={1} style={{textAlign:'center'}}>        
         <CopyRepElement 
            title={`SUMMARY DECLARATION/PREVIOUS DOCUMENTS`}
            request={{type, code, docRef, goodsItemIdentifier}}
            callback={copyData}
            isFormDisabled={isDisabled}
         />
      </Grid.Column>
      )}
      <Grid.Column width='4' className='divFormFeild border-bottom  b-rw-0'>
        <DropDown
          id={`docCategory-${id}`}
          disabled={isFormDisabled}
          className='field-bg dropdown100 addInfoCode'
          labelClass='text-none'
          label='DOC CATEGORY'
          isLabel={true}
          data={documentCategories}
          value={code}
          clearable
          onChange={(value) => {
            saveData({ id, code: value || ' ' })
            updateData(id, { code: value })
          }}
        />
      </Grid.Column>
      <Grid.Column width={isItemTab ?'3':'4'} className='divFormFeild border-bottom  b-rw-0'>
        <DropDown
          id={`docType-${id}`}
          disabled={isFormDisabled}
          className='field-bg dropdown100'
          labelClass='text-none'
          label='DOC TYPE'
          isLabel={true}
          data={previousDocumentsType}
          clearable
          value={type}
          onChange={(value) => {
            saveData({ id, type: value || ' ' })
            updateData(id, { type: value })
          }}
        />
      </Grid.Column>

      <Grid.Column width='3' className='divFormFeild  border-bottom b-rw-0'>
        <InputField
          isLabel={false}
          id={`docRef-${id}`}
          type='text'
          label='DOC REFERENCE'
          value={docRef}
          className='field-bg'
          clearable
          disabled={isFormDisabled}
          onChange={(value) => updateData(id, { docRef: value })}
          onBlur={(value) => saveData({ id, docRef: docRef || ' ' })}
        />
      </Grid.Column>
      <Grid.Column width='4' className='divFormFeild border-bottom'>
        <InputField
          id={`goodsItem-${id}`}
          disabled={isFormDisabled}
          type='text'
          label='Goods Item Identifier'
          value={goodsItemIdentifier}
          //errors={getValidationError("goodsItemIdentifier",goodsItemIdentifier)}
          className='field-bg'
          clearable
          onChange={(value) => updateData(id, { goodsItemIdentifier: value })}
          onBlur={(value) => {saveData({ id, goodsItemIdentifier: goodsItemIdentifier || ' ' })
          // let err = getValidationError('goodsItemIdentifier', goodsItemIdentifier, 'headerTab')
          //       err.length
          //         ? addErrors('headerTab', err[0], 'goodsItemIdentifier')
          //         : deleteErrors('headerTab', '', 'goodsItemIdentifier')
        }}
        />
      </Grid.Column>
      <Grid.Column width='1' className='icon-delete-add-info'>
        <DeleteIcon id={`prevDocumentDelete-${id}`} onClick={() =>deleteData(id)} disabled={isFormDisabled} />
      </Grid.Column>
    </Grid.Row>
  )
}

export default React.memo(PreviousDocumentsDetails);
